export enum PLAN_TYPE {
    MONTHLY = "monthly",
    INSTALLMENT = "installment",
    YEARLY = "yearly",
    QUARTERLY = "quarterly"
}
